import { Button } from "@circle-react-uikit/Button";

interface ConfirmButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export const ConfirmButton = ({
  children,
  onClick = undefined,
  disabled = false,
}: ConfirmButtonProps) => (
  <Button
    large
    className="!bg-[#18AB4A] text-white hover:bg-[#18AB4A]/80"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </Button>
);
